import { useCallback, useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { separateNum } from "../../../utils";
import { setUser } from "../../../store/action/auth";
import { cartsChanged } from "../../../store/action/cart";
import CartService from "../../../services/cart/Cart";
import HttpService from "../../../services/http_service/HttpService";
import Http from "../../../services/http/Http";
import Notification from "../../../services/notification/Notification";
import { Warning } from "../../../components/button";
import CreateAddress from "../../profile/addresses/create";
import SideBar from "../SideBar";
import Item from "./Item";
import { Div, Row, Col, Container } from "./style";

const Shipping = (props) => {
  const { history, user, carts, cartsChanged, settings } = props;

  const createAddressRef = useRef();

  const [isLoadingGetData, setIsLoadingGetData] = useState(false);
  const [isLoadingSendData, setIsLoadingSendData] = useState(false);
  const [shippings, setShippings] = useState([]);

  const getShipping = useCallback(() => {
    setIsLoadingGetData(true);

    HttpService(user?.token)
      .get("shippings/address")
      .then((response) => {
        setShippings(response?.data?.entity);
      })
      .catch((error) => {
        Http(error?.response?.status, error?.response?.data?.message, props);
      })
      .finally(() => {
        setIsLoadingGetData(false);
      });
  }, [user]);

  useEffect(() => {
    window.scrollTo(0, 0);

    getShipping();
  }, [getShipping]);

  const nextLevel = () => {
    if (CartService.getCartPrice(carts)?.price > settings.min_order) {
      if (carts?.shipping?.id) {
        if (carts?.shipping?.id !== 2) {
          if (user?.address) {
            sendCart();
          } else {
            createAddressRef.current.changeStatus();

            Notification.danger("ابتدا یک آدرس تعیین کنید");
          }
        } else {
          sendCart();
        }
      } else {
        Notification.danger("ابتدا نحوه ارسال را تعیین کنید");
      }
    } else {
      Notification.danger(
        `سفارش شما باید حداقل ${separateNum(settings.min_order)} تومان باشد.`
      );
    }
  };

  const sendCart = () => {
    setIsLoadingSendData(true);

    HttpService(user?.token)
      .patch("carts", {
        ...carts,
        shipping_id: carts?.shipping?.id,
      })
      .then((response) => {
        if (
          response?.data?.entity?.items &&
          Object.keys(response?.data?.entity?.items)
        ) {
          if (response?.data?.entity?.cart_updated) {
            Notification.danger(response?.data?.message);
          }

          CartService.setCart(response.data?.entity, cartsChanged);

          onChangeRoute("/carts/checkout");
        } else if (!response?.data?.entity?.items) {
          Notification.danger("غذای انتخابی شما ناموجود میباشد.");

          CartService.setCart(response.data?.entity, cartsChanged);

          history.push("/");
        }
      })
      .catch((error) => {
        Http(error?.response?.status, error?.response?.data?.message, props);
      })
      .finally(() => {
        setIsLoadingSendData(false);
      });
  };

  const onChangeRoute = (route, e, data) => {
    if (e) {
      e.preventDefault();
    }

    history.push(route, data);
  };

  return (
    <>
      <CreateAddress refrence={createAddressRef} />
      <Div className="mx-1 mt-3">
        <Row className="row no-gutters">
          {isLoadingGetData ? (
            false
          ) : (
            <>
              <Col className="col-12 mb-2">
                <Container>
                  {shippings.map((shipping, index) => {
                    if (Boolean(shipping.status) === false) return false;

                    return <Item key={index} data={shipping} />;
                  })}
                </Container>
              </Col>
              <SideBar local>
                <Warning
                  title="تایید و ثبت نهایی"
                  className="d-block mt-3"
                  onClick={nextLevel}
                  isLoading={isLoadingSendData}
                  sizeSpinner={20}
                />
              </SideBar>
            </>
          )}
        </Row>
      </Div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    settings: state.settings?.settings,
    carts: state.carts?.carts,
  };
};

export default connect(mapStateToProps, { setUser, cartsChanged })(Shipping);
